(function () {
  'use strict';
  var form = document.querySelector('form.cart');
  if (!form) return;
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  var busy = false, unlock = function () {}, pendingKey = 'pt-cart-quantity-pending-v2', messageKey = 'pt-cart-quantity-message-v2';
  var widgets = Array.from(form.querySelectorAll('[data-pt-quantity-key]'));
  var stockEl = document.getElementById('pt-cart-stock-data');
  var unavailable = 'Die gewünschte Anzahl ist für das Geschenk oder eines der Extras nicht verfügbar. Deine bisherige Auswahl bleibt erhalten.';

  async function request(path, body) {
    var response = await fetch(root + path, {method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}, body: body ? JSON.stringify(body) : undefined});
    var data = await response.json();
    if (!response.ok) throw new Error(response.status === 422 ? unavailable : 'Die Anzahl konnte nicht geändert werden. Bitte versuche es erneut.');
    return data;
  }
  function stateFrom(doc) {
    var stock = doc.querySelector('#pt-cart-stock-data'), cart = doc.querySelector('[id^="CartJson-"]');
    if (!stock || !cart) throw new Error('Der Bestand konnte nicht geprüft werden. Bitte lade den Warenkorb neu.');
    return {cart: JSON.parse(cart.textContent), stock: JSON.parse(stock.textContent)};
  }
  async function freshState() {
    if (!stockEl) throw new Error('Bitte lade den Warenkorb neu, um den Bestand zu prüfen.');
    var response = await fetch(root + 'cart?section_id=' + encodeURIComponent(stockEl.dataset.section) + '&_pt_stock=' + Date.now(), {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error('Der Bestand konnte nicht geprüft werden. Bitte versuche es erneut.');
    return stateFrom(new DOMParser().parseFromString(await response.text(), 'text/html'));
  }
  function propertiesKey(item) {
    var props = item.properties || {};
    return JSON.stringify(Object.keys(props).sort().map(function (key) { return [key, props[key]]; }));
  }
  function findLine(cart, original) {
    var exact = cart.items.find(function (line) { return line.key === original.key; });
    if (exact) return exact;
    var matches = cart.items.filter(function (line) { return line.variant_id === original.variant_id && propertiesKey(line) === propertiesKey(original) && JSON.stringify(line.selling_plan_allocation || null) === JSON.stringify(original.selling_plan_allocation || null); });
    return matches.length === 1 ? matches[0] : null;
  }
  function group(cart, item) {
    if (!item || !item.properties || item.properties._pt_no_tree !== '1') throw new Error('Der Warenkorb hat sich geändert. Bitte lade die Seite neu.');
    var bid = item.properties._pt_bundle_id;
    var lines = bid ? cart.items.filter(function (line) { return line.properties && line.properties._pt_bundle_id === bid; }) : [item];
    if (lines.some(function (line) { return ['tree_base', 'extra', 'print', 'frame', 'paper_upgrade', 'gift_paper'].includes((line.properties || {})._pt_role) || (line.key !== item.key && (line.properties || {})._pt_hidden !== '1'); })) throw new Error('Dieses Geschenk bitte einzeln personalisieren.');
    return lines;
  }
  function limit(state, item, lines) {
    var units = {}, maximum = Infinity, keys = new Set(lines.map(function (line) { return line.key; }));
    lines.forEach(function (line) { units[line.variant_id] = (units[line.variant_id] || 0) + line.quantity / item.quantity; });
    Object.keys(units).forEach(function (variantId) {
      var stock = state.stock.find(function (row) { return String(row.variant_id) === variantId; });
      if (!stock) throw new Error('Der Bestand konnte nicht vollständig geprüft werden. Bitte lade die Seite neu.');
      if (!stock.managed || stock.policy === 'continue') return;
      var elsewhere = state.cart.items.filter(function (line) { return String(line.variant_id) === variantId && !keys.has(line.key); }).reduce(function (sum, line) { return sum + line.quantity; }, 0);
      maximum = Math.min(maximum, Math.max(0, Math.floor((stock.quantity - elsewhere) / units[variantId])));
    });
    return maximum;
  }
  function showLimit(widget, maximum, current) {
    var input = widget.querySelector('input'), note = widget.querySelector('.pt-cart-quantity-stock');
    if (!note) { note = document.createElement('span'); note.className = 'pt-cart-quantity-stock'; widget.appendChild(note); }
    if (Number.isFinite(maximum)) {
      input.max = maximum;
      note.textContent = maximum > 0 ? 'Maximal ' + maximum + ' mit deinen gewählten Extras verfügbar.' : 'Diese Kombination ist aktuell nicht verfügbar. Bitte entferne sie oder ändere die Extras.';
    } else { input.removeAttribute('max'); note.textContent = ''; }
    widget.dataset.ptOverstock = current > maximum ? '1' : '0';
    widget.querySelector('[data-pt-quantity-step="1"]').disabled = busy || current >= maximum;
  }
  function lock() {
    busy = true; form.setAttribute('aria-busy', 'true');
    var controls = Array.from(form.querySelectorAll('input,button,select,textarea')), previous = controls.map(function (el) { return el.disabled; });
    controls.forEach(function (el) { el.disabled = true; });
    unlock = function () { controls.forEach(function (el, i) { el.disabled = previous[i]; }); form.removeAttribute('aria-busy'); busy = false; };
  }
  async function restore(lines) {
    var cart = await request('cart.js'), updates = {};
    lines.forEach(function (old) {
      var current = findLine(cart, old);
      if (!current) throw new Error('Die bisherige Auswahl konnte noch nicht vollständig wiederhergestellt werden.');
      if (current.quantity !== old.quantity) updates[current.key] = old.quantity;
    });
    // update.js is used only to restore the pre-change quantities after a failed operation.
    if (Object.keys(updates).length) cart = await request('cart/update.js', {updates: updates});
    if (lines.some(function (old) { var line = findLine(cart, old); return !line || line.quantity !== old.quantity; })) throw new Error('Die bisherige Auswahl konnte noch nicht vollständig wiederhergestellt werden.');
    sessionStorage.removeItem(pendingKey);
  }
  function recoveryBlocked(lines) {
    var notice = document.createElement('div'); notice.setAttribute('role', 'alert');
    notice.textContent = 'Die Mengenänderung konnte nicht abgeschlossen werden. Bitte stelle vor dem Bezahlen deine bisherige Auswahl wieder her. ';
    var retry = document.createElement('button'); retry.type = 'button'; retry.dataset.ptQuantityRecover = '1'; retry.textContent = 'Erneut prüfen';
    retry.addEventListener('click', async function () { retry.disabled = true; try { await restore(lines); location.reload(); } catch (_) { retry.disabled = false; } });
    notice.appendChild(retry); form.prepend(notice);
  }
  async function changeQuantity(widget, quantity) {
    if (busy) return;
    var input = widget.querySelector('input'), status = widget.querySelector('[role="status"]');
    if (!Number.isSafeInteger(quantity) || quantity < 1) { status.textContent = 'Bitte gib eine ganze Anzahl ab 1 ein.'; input.value = input.defaultValue; return; }
    if (quantity === Number(input.defaultValue)) return;
    lock(); status.textContent = 'Bestand wird geprüft …';
    var lines, state, item, maximum, started = false;
    try {
      state = await freshState();
      item = state.cart.items.find(function (line) { return line.key === widget.dataset.ptQuantityKey; });
      lines = group(state.cart, item); maximum = limit(state, item, lines);
      // Reductions remain possible when an older cart already exceeds today's stock.
      if (quantity > maximum && quantity >= item.quantity) throw new Error(maximum > 0 ? 'Mit deinen gewählten Extras sind maximal ' + maximum + ' verfügbar. Die Anzahl wurde nicht geändert.' : unavailable);
      var targets = lines.map(function (line) { var amount = line.quantity * quantity / item.quantity; if (!Number.isSafeInteger(amount) || amount < 1) throw new Error('Die Extras konnten nicht zugeordnet werden. Bitte lade die Seite neu.'); return amount; });
      sessionStorage.setItem(pendingKey, JSON.stringify(lines));
      var cart = state.cart; started = true; status.textContent = 'Anzahl wird aktualisiert …';
      for (var i = 0; i < lines.length; i++) {
        var current = findLine(cart, lines[i]);
        if (!current) throw new Error('Der Warenkorb hat sich geändert. Bitte versuche es erneut.');
        // change.js enforces Shopify's current inventory rules for every component.
        cart = await request('cart/change.js', {id: current.key, quantity: targets[i]});
        var changed = findLine(cart, lines[i]);
        if (!changed || changed.quantity !== targets[i]) throw new Error(unavailable);
      }
      if (lines.some(function (old, index) { var line = findLine(cart, old); return !line || line.quantity !== targets[index]; })) throw new Error(unavailable);
      sessionStorage.removeItem(pendingKey); window.location.reload();
    } catch (error) {
      if (started) {
        try { await restore(lines); sessionStorage.setItem(messageKey, error.message); window.location.reload(); return; }
        catch (_) { recoveryBlocked(lines); return; }
      }
      status.textContent = error.message || 'Die Anzahl konnte nicht geändert werden. Bitte versuche es erneut.';
      input.value = input.defaultValue; unlock();
      if (maximum !== undefined) showLimit(widget, maximum, Number(input.defaultValue));
    }
  }
  function blockCheckout(event) {
    var invalid = widgets.find(function (widget) { return widget.dataset.ptOverstock === '1'; });
    if (busy || invalid) { event.preventDefault(); event.stopImmediatePropagation(); if (!busy && invalid) { invalid.querySelector('[role="status"]').textContent = 'Bitte passe die Anzahl an den verfügbaren Bestand an.'; invalid.querySelector('input').focus(); } }
  }
  form.addEventListener('submit', blockCheckout, true);
  form.addEventListener('click', function (event) {
    if (event.target.closest('[data-pt-quantity-recover]')) return;
    if (busy && event.target.closest('a,button')) { event.preventDefault(); event.stopImmediatePropagation(); }
    else if (event.target.closest('[name="checkout"],a[href*="/checkout"]')) blockCheckout(event);
  }, true);
  widgets.forEach(function (widget) {
    var input = widget.querySelector('input');
    widget.querySelectorAll('[data-pt-quantity-step]').forEach(function (button) { button.addEventListener('click', function () { changeQuantity(widget, Number(input.value) + Number(button.dataset.ptQuantityStep)); }); });
    input.addEventListener('change', function (event) { event.stopPropagation(); changeQuantity(widget, Number(input.value)); });
    input.addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); changeQuantity(widget, Number(input.value)); } });
    try { var state = stateFrom(document), item = state.cart.items.find(function (line) { return line.key === widget.dataset.ptQuantityKey; }); showLimit(widget, limit(state, item, group(state.cart, item)), item.quantity); }
    catch (_) { widget.querySelector('[role="status"]').textContent = 'Der Bestand wird bei deiner Mengenänderung geprüft.'; }
  });
  try {
    var message = sessionStorage.getItem(messageKey);
    if (message && widgets.length) { widgets[0].querySelector('[role="status"]').textContent = message; sessionStorage.removeItem(messageKey); }
    var pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
    if (pending) { lock(); restore(pending).then(function () { location.reload(); }).catch(function () { recoveryBlocked(pending); }); }
  } catch (_) {}
})();
